import request from '@/utils/request'

/**
 * 系统（管理员 / 操作日志）接口
 *
 * 全部复用已有的系统模块接口：
 *   /sys/user/page          管理员分页
 *   /sys/user/{id}          管理员详情（含 roleIdList）
 *   /sys/role/page          角色列表（name + remark 作为权限说明）
 *   /sys/log/login/page     登录日志（用于推算最后登录时间）
 *   /sys/log/operation/page 操作日志
 */

export function getSysUserPage (params) {
  return request({
    url: '/sys/user/page',
    method: 'get',
    params
  })
}

export function getSysUserInfo (id) {
  return request({
    url: `/sys/user/${id}`,
    method: 'get'
  })
}

/**
 * 修改管理员（启用 / 禁用走这里）
 */
export function updateSysUser (data) {
  return request({
    url: '/sys/user',
    method: 'put',
    data
  })
}

export function getRolePage (params) {
  return request({
    url: '/sys/role/page',
    method: 'get',
    params
  })
}

export function getLoginLogPage (params) {
  return request({
    url: '/sys/log/login/page',
    method: 'get',
    params
  })
}

export function getOperationLogPage (params) {
  return request({
    url: '/sys/log/operation/page',
    method: 'get',
    params
  })
}

// 管理员状态
export const USER_STATUS = {
  DISABLED: 0,
  ENABLED: 1
}

/**
 * 请求地址 -> 业务模块名
 * 操作日志表没有模块字段，按 requestUri 前缀推导
 */
const MODULE_RULES = [
  { prefix: '/sys/user', name: '管理员' },
  { prefix: '/sys/role', name: '角色管理' },
  { prefix: '/sys/menu', name: '菜单管理' },
  { prefix: '/sys/params', name: '参数管理' },
  { prefix: '/sys/dict', name: '数据字典' },
  { prefix: '/sys/dept', name: '部门管理' },
  { prefix: '/sys/oss', name: '文件管理' },
  { prefix: '/sys/log', name: '日志管理' },
  { prefix: '/user/user', name: '用户管理' },
  { prefix: '/payOrder', name: '订单管理' },
  { prefix: '/payConfig', name: '支付通道' },
  { prefix: '/payManualOrder', name: '人工补单' },
  { prefix: '/commodity', name: '套餐管理' },
  { prefix: '/moviesinfo', name: '视频管理' },
  { prefix: '/movies', name: '视频管理' },
  { prefix: '/novelinfo', name: '小说管理' },
  { prefix: '/novel', name: '小说管理' },
  { prefix: '/sondict', name: '分类标签' },
  { prefix: '/dict', name: '分类标签' },
  { prefix: '/appconfig', name: '站点配置' },
  { prefix: '/agent', name: '代理管理' },
  { prefix: '/withdrawal', name: '提现管理' },
  { prefix: '/swiper', name: '轮播管理' },
  { prefix: '/barrage', name: '弹幕管理' },
  { prefix: '/crypto', name: '数字货币' }
]

/**
 * 由请求地址推导模块名
 */
export function resolveModule (requestUri) {
  const uri = String(requestUri || '')
  if (!uri) {
    return '—'
  }
  const matched = MODULE_RULES.find(rule => uri.indexOf(rule.prefix) === 0)
  if (matched) {
    return matched.name
  }
  // 兜底：取地址第一段
  const segment = uri.split('/').filter(Boolean)[0]
  return segment || '—'
}
